import { SettingsColorPicker } from '@/pages/branding/sections/colorPicker/SettingsColorPicker.tsx'
import { createColorShades } from '@/pages/branding/sections/createColorShades.ts'
import { GeneratedPalette } from '@/pages/branding/sections/generatedPalette/GeneratedPalette.tsx'
import { Col, Row } from 'antd'
import { ColorPalette } from 'common/util/colorPalette.ts'
import React from 'react'

interface Props {
  colorPalette: ColorPalette
  setColorPalette: (value: ColorPalette) => void
}

export const SettingsPrimarySecondary: React.FC<Props> = ({ colorPalette, setColorPalette }) => (
  <>
    <Row style={{ marginBottom: 2 }}>
      <Col>
        <h3>Primary color:</h3>
      </Col>
    </Row>

    <Row style={{ marginBottom: 12 }}>
      <Col>
        <SettingsColorPicker
          value={colorPalette['--color-primary-1']}
          onChange={(color) => {
            const shades = createColorShades(color)

            setColorPalette({
              ...colorPalette,
              '--color-primary-1': shades.color,
              '--color-primary-2': shades.firstShade,
              '--color-primary-3': shades.secondShade,
            })
          }}
          generatedPalette="primary"
        />
      </Col>
    </Row>

    <Row style={{ marginBottom: 32 }}>
      <Col>
        <GeneratedPalette type="primary" />
      </Col>
    </Row>

    <Row style={{ marginBottom: 2 }}>
      <Col>
        <h3>Secondary color (charts, active menu tab):</h3>
      </Col>
    </Row>

    <Row style={{ marginBottom: 12 }}>
      <Col>
        <SettingsColorPicker
          value={colorPalette['--color-secondary-1']}
          onChange={(color) => {
            const shades = createColorShades(color)

            setColorPalette({
              ...colorPalette,
              '--color-secondary-1': shades.color,
              '--color-secondary-2': shades.firstShade,
              '--color-secondary-3': shades.secondShade,
            })
          }}
          generatedPalette="secondary"
        />
      </Col>
    </Row>

    <Row>
      <Col>
        <GeneratedPalette type="secondary" />
      </Col>
    </Row>
  </>
)
